import { render, staticRenderFns } from "./selfPassword.vue?vue&type=template&id=39abc627&scoped=true"
import script from "./selfPassword.vue?vue&type=script&lang=js"
export * from "./selfPassword.vue?vue&type=script&lang=js"
import style0 from "./selfPassword.vue?vue&type=style&index=0&id=39abc627&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39abc627",
  null
  
)

export default component.exports